import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  GetJobList,
  checkCompanyLinkedInStatus,
  updateArchiveStatus,
  updatestatus,
} from "../../services/JobService";
import { useState, useEffect, useRef } from "react";
import api from "../../api";
import { toast } from "react-toastify";
import Select from "react-select";
import action3 from "../../assets/images/brands/Rejected.svg";
import screening_icon from "../../assets/images/brands/Selected.svg";
import progress_icon from "../../assets/images/brands/In-progess.svg";
import pending_icon from "../../assets/images/brands/Pending.svg";
import { checkPermissionStatus } from "helpers/utils";
import { getLinkedInAuthUrl } from "helpers/linkedinAuthHelper";
import { getUserToken } from "helpers/authHelper";
import edit_icon from "../../assets/images/icon/edit.svg";
import delete_icon from "../../assets/images/icon/delete.svg";
import white_delete from "../../assets/images/icon/white-delete.svg";
import archive_ico from "../../assets/images/icon/archive_ico.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import { decryptDataFromArray } from "helpers/EncDec";
import application_tracker from "../../assets/images/icon/application-tracker.svg";

import archived_icon from "../../assets/images/icon/archived-icon.svg";
import white_cross from "../../assets/images/icon/white-cross.svg";
import { useTranslation } from "react-i18next";

const ArchiveJobs = props => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [profile, setProfile] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [queryString, setQueryString] = useState("");
  const [checkId, setCheckId] = useState("");
  const [modelMessage, setModelMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const subdomain = localStorage.getItem("subdomain")?.toLowerCase();
  useEffect(() => {
    // Extract the query string part of the URL
    const search = window.location.search;

    if (search) {
      // Remove the question mark and set the state
      setQueryString(search.substring(1));
    }
  }, []);

  const loaderStyle = {
    border: "4px solid rgba(0, 0, 0, 0.1)",
    borderLeftColor: "#000",
    borderRadius: "50%",
    width: "16px",
    height: "16px",
    animation: "spin 1s linear infinite",
  };

  const fetchJobList = async () => {
    let language_id = localStorage.getItem("lang_id");
    if (language_id) {
      GetJobList("archived")
        .then(res => {
          let responseData = res.data;
          responseData = decryptDataFromArray(responseData);

          if (responseData?.status) {
            setData(responseData?.data);
          }
        })
        .catch(err => {
          toast.error(t(`job-list.No data Available`));
        });
    }
  };
  const fetchJobListActve = async () => {
    GetJobList("draft")
      .then(res => {
        let responseData = res.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          props.setData(responseData?.data);
        }
      })
      .catch(err => {
        // toast.error(t(`job-list.No data Available`));
      });
  };

  useEffect(() => {
    checkCompanyLinkedInStatus()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          setCompanyData(responseData?.data);
        }
      })
      .catch(err => {
        toast.error(t(`job-list.No data Available`));
      });

    fetchJobList();
    document.title = "NeuroTal - Positions";
  }, []);

  const handleConfirm = async () => {
    setIsLoading(true);

    const job_data = {
      jobId: checkId,
    };
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/job/linkedin-job-post/`,
        job_data,
        {
          headers: {
            Authorization: getUserToken(),
            "X-DomainID": localStorage.getItem("subdomainId") || "",
            "X-lang_id": localStorage.getItem("lang_id") || "",
          },
        }
      );
      if (response.status === 200) {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        setShowModal(false); // Close the modal
      } else {
        toast.error(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        setShowModal(false); // Close the modal
      }
    } catch (error) {
      // Handling error response
      if (error.response) {
        let errorMessage = t(`job-list.Error msg 2`);
        switch (error.response.status) {
          case 400:
            errorMessage += t(`job-list.Error msg 3`);
            break;
          case 422:
            errorMessage += t(`job-list.Error msg 4`);
            break;
          case 401:
            errorMessage += t(`job-list.Error msg 5`);
            break;
          case 403:
            errorMessage += t(`job-list.Error msg 6`);
            break;
          case 404:
            errorMessage += t(`job-list.Error msg 7`);
            break;
          case 500:
            errorMessage += t(`job-list.Error msg 8`);
            break;
          default:
            errorMessage += t(`job-list.Error msg 9`);
        }
        toast.error(errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
        if (error.response.status === 401 || error.response.status === 505) {
          if (companyData?.linkedin === 1) {
            let clientIdLinkedIn = companyData?.client_id_linkedin;
            let clientsecretslinkedin = companyData?.client_secrets_linkedin;
            let scopelinkedin = companyData?.scope_linkedin;
            window.location.href = getLinkedInAuthUrl(
              clientIdLinkedIn,
              clientsecretslinkedin,
              scopelinkedin
            );
          } else {
            toast.error("Linkedin Detail not configured in your panel", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        }
        //alert(errorMessage);
      } else if (error.request) {
        // Request was made but no response received
        console.error("Error request data:", error.request);
        alert(
          "Error posting job to LinkedIn: No response received from server."
        );
      } else {
        // Something happened in setting up the request
        console.error("Error message:", error.message);
        //alert(`Error posting job to LinkedIn: ${error.message}`);
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      setIsLoading(false);
      setShowModal(false); // Close the modal
    }
  };

  const handleClose = () => {
    setIsLoading(false);
    setCheckId("");
    setShowModal(false); // Close the modal
  };

  const handleJobLinkedIn = async jobId => {
    const job_data = {
      jobId: jobId,
    };
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/job/check-already-posted-job`,
        job_data,
        {
          headers: {
            Authorization: getUserToken(),
            "X-DomainID": localStorage.getItem("subdomainId") || "",
            "X-lang_id": localStorage.getItem("lang_id") || "",
          },
        }
      );
      if (response.status === 200) {
        setCheckId(jobId);
        setModelMessage(t(`job-list.Linkedin Post again`));
        setShowModal(true);
      } else {
        setCheckId(jobId);
        setModelMessage(t(`job-list.Linkedin Post`));
        setShowModal(true);
      }
    } catch (error) {
      console.log("Error in check api", error);
    }
  };

  const handleJobLinkedIn1 = async jobId => {
    const job_data = {
      jobPostId: "3656592984",
    };
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/admin/job/get-user-data-posted-job`,
        job_data,
        {
          headers: {
            Authorization: getUserToken(),
            "X-DomainID": localStorage.getItem("subdomainId") || "",
          },
        }
      );
      
    } catch (error) {
      console.log("Error in check api", error);
    }
  };

  const setAllArchive = async type => {
    let jobs = data.filter(val => val?.checked).map(val => val?.id);
    const response = await api.post(
      `${process.env.REACT_APP_API_URL}/admin/job/bulk-update-jobs`,
      { jobs: jobs, type: type },
      {
        headers: {
          Authorization: getUserToken(),
          "X-DomainID": localStorage.getItem("subdomainId") || "",
          "X-lang_id": localStorage.getItem("lang_id") || "",
        },
      }
    );
    if (response.status === 200) {
      fetchJobListActve();
      fetchJobList();
      toast.success(t(`job-list.Success msg 1`));
    }
    try {
    } catch (error) {
      console.log("ERROR", error?.message);
      toast.error("job-list.Error on bulk Update");
    }
  };

  ///modal
  const [isVisible, setIsVisible] = useState(false);

  const filter_icon = () => {
    setIsVisible(!isVisible);
  };

  const close = () => {
    setIsVisible(false);
  };

  // const checkboxFormatter = (cell, row, rowIndex, formatExtraData) => {
  //   return (
  //     <input
  //       type="checkbox"
  //       onClick={() => formatExtraData.toggleDiv(rowIndex)} // Correctly accessing toggleDiv
  //     />
  //   );
  // };

  const checkboxFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <input
          type="checkbox"
          id={`checkbox-${rowIndex}`} // Unique id for the checkbox
          checked={row?.checked}
          onChange={e => toggleCheckbox(rowIndex, e?.target?.checked)}
        />
        <label
          htmlFor={`checkbox-${rowIndex}`}
          className="sr-only check_pskdkeij"
        >
          Select row
        </label>
      </div>
    );
  };

  const [visibleDivIndex, setVisibleDivIndex] = useState(null);

  const toggleCheckbox = (rowIndex, val) => {
    let result = data.map((elem, index) =>
      index === rowIndex ? { ...elem, checked: val } : elem
    );
    setData(result);
  };

  const handleSelectAll = e => {
    let result = data.map((elem, index) => ({
      ...elem,
      checked: e?.target?.checked,
    }));
    setData(result);
  };
  const checkboxColumn = {
    dataField: "checkbox",
    text: "",
    formatter: checkboxFormatter,
    headerFormatter: () => (
      <div style={{ position: "relative" }}>
        <label htmlFor="select-all-checkbox" className="sr-only">
          Select all rows
        </label>
        <input
          type="checkbox"
          id="select-all-checkbox"
          checked={data?.length > 0 ? data?.every(val => val?.checked) : false}
          onChange={e => handleSelectAll(e)}
          aria-label="Select all rows"
        />
      </div>
    ),
    headerClasses: "checkbox-column",
    classes: "checkbox-column",
    isDummyField: true,
  };
  //Bootstrap table columns
 let columns = [
    ...(subdomain === "mahindra"
      ? [
          {
            dataField: "JobMaster.job_title",
            text: t(`job-list.Job Title`),
            classes: "mobile-width-row strong-cl",
            headerClasses: "mobile-width-row",
            formatter: (cell, row) => (
              <Link
                to={{
                  pathname: `/job-details/${row.id}`,
                  state: "tab3",
                }}
                className="job-title-link"
              >
                {cell}
              </Link>
            ),
          },
        ]
      : []),

    ...(subdomain !== "mahindra"
      ? [
          {
            dataField: "title",
            text: t(`job-list.Job_Position`),
            classes: "mobile-width-row strong-cl",
            headerClasses: "mobile-width-row",
            formatter: (cell, row) => (
              <Link
                to={{
                  pathname: `/job-details/${row.id}`,
                  state: "tab3",
                }}
                className="job-title-link"
              >
                {cell}
              </Link>
            ),
          },
        ]
      : []),
    {
      dataField: "dealership_name",
      text: t(`job-list.dealer_name`),
      classes: "white-hidden mobile-width-row experience-row",
      headerClasses: "mobile-width-row experience-row",
    },
    {
      dataField: "created_by",
      text: t(`job-list.created_by`),
      classes: "white-hidden mobile-width-row experience-row",
      headerClasses: "mobile-width-row experience-row",
    },
    // {
    //   dataField: "title",
    //   text: t(`job-list.Job_Position`),
    //   classes: "mobile-width-row strong-cl",
    //   headerClasses: "mobile-width-row",
    // },
    {
      dataField: "experience",
      text: t(`job-list.Experience`),
      classes: "white-hidden mobile-width-row experience-row",
      headerClasses: "mobile-width-row experience-row",
    },
    {
      dataField: "qualification",
      text: t(`job-list.Qualification Required`),
      classes: "mobile-width-row",
      headerClasses: "mobile-width-row",
    },
  
  ];

    if (checkPermissionStatus("job-list", "edit")) {
      columns = [checkboxColumn, ...columns];
    }

  if (checkPermissionStatus("job-list", "edit")) {
    columns.push({
      dataField: "id",
      text: t(`job-list.Actions`),
      formatter: (cell, row) => {
        let vacancy_id = row?.id;
        let currentStatus = parseInt(row?.status);
        return (
          <div className="d-flex gap-2 blue-icon-gap">
            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/job-posting/${cell}`}
              >
                <img src={application_tracker} alt="delete_icon" />
                <span>{t(`job-list.Application Tracking`)}</span>
              </Link>
            </div>

            <div className="action-one small-img">
              <Link
                className="text-success blue-icon blue-color4"
                to={`/edit-job-new/${cell}`}
              >
                <img src={edit_icon} alt="edit_icon" />
                <span>{t(`job-list.Edit Job`)}</span>
              </Link>
            </div>

            <div className="action-one small-img">
              <div
                className="text-success blue-icon blue-color3"
                onClick={() => handleJobDelete(cell)}
                style={{ cursor: "pointer" }}
              >
                <img src={delete_icon} alt="delete_icon" />
                <span>{t(`job-list.Delete`)}</span>
              </div>
            </div>

            <div className="d-flex gap-2 blue-icon-gap">
              <div className="action-one small-img">
                <div
                  className="text-success blue-icon blue-color4"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    handleUnarchiveJob(vacancy_id);
                  }}
                >
                  <img src={archived_icon} alt="delete_icon" />
                  <span>{t(`job-list.Unarchive`)}</span>
                </div>
              </div>
            </div>
          </div>
        );
      },
    });
  }

  const statusUpdateOptions = [
    {
      label: (
        <>
          <img src={pending_icon} alt="" /> {t(`job-list.Pending`)}
        </>
      ),
      value: "0",
    },
    {
      label: (
        <>
          <img src={progress_icon} alt="" /> {t(`job-list.Approve`)}
        </>
      ),
      value: "1",
    },
    {
      label: (
        <>
          <img src={screening_icon} alt="" /> {t(`job-list.Post`)}
        </>
      ),
      value: "2",
    },
    {
      label: (
        <>
          <img src={action3} alt="" /> {t(`job-list.Reject`)}
        </>
      ),
      value: "3",
    },
  ];

  const handleUnarchiveJob = async vacancy_id => {
    if (vacancy_id) {
      if (checkPermissionStatus("job-list", `edit`)) {
        await updateArchiveStatus(vacancy_id, 1)
          .then(res => {
            if (res.status === 200) {
              toast.success(t(`job-list.Success msg 5`));
              fetchJobList();
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch(error => {
            // console.log(error);
            toast.error(error);
          });
      } else {
        toast.error(t(`job-list.Error msg 1`));
      }
    } else {
      // console.log("Validation error:", commentError);
    }
    // window.location.reload();
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`job-list.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "Next page",
    prePageTitle: "Pre page",
    firstPageTitle: "First page", 
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  //Delete Reclords

  const handleJobDelete = jobId => {
    if (window.confirm("Are you sure you want to delete this Job?")) {
      api
        .delete(
          `${process.env.REACT_APP_API_URL}/admin/job/delete-job/${jobId}`
        )
        .then(response => {
          let { success } = response.data;

          if (success) {
            fetchJobList();
          }
        })
        .catch(err => {});
    }
  };

  const rowClasses = (row, rowIndex) => {
    let baseClass = rowIndex % 2 === 0 ? "even-row" : "odd-row";

    if (row.id !== undefined && row.id < 10) {
      return `${baseClass} ijuuhsdhsyhsdyhs`;
    }

    return baseClass;
  };

  const hasIdBelow10 = data.some(item => item.id < 10);

  const tbodyRef = useRef(null);

  useEffect(() => {
    if (tbodyRef.current) {
      if (data.length < 10) {
        tbodyRef.current.style.height = "700px";
      } else {
        tbodyRef.current.style.height = "auto";
      }
    }
  }, [data.length]);

  

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  //active-tabs-smooth
  const [activeTab, setActiveTab] = useState("tab1"); // Default active tab

  const handleTabClick = tab => {
    setActiveTab(tab);
  };
  
if (!checkPermissionStatus("job-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">{t(`job-list.Access Denied`)}</h4>
      </div>
    );
  }
  return (
    <>
      <div className="outerTab-box-wrapper applicationcard-table darftjobs pt-0">
        <div className="tale-text right-panel left-before-list m-0 tabs-3-tab">
          <button
            className="button left"
            onClick={() => handleScroll("left")}
            data-tooltip="Scroll Left"
          >
            <img src={right_arrow} alt="right-arrow" />
          </button>
          <button
            className="button right"
            onClick={() => handleScroll("right")}
            data-tooltip="Scroll Right"
          >
            <img src={right_arrow} alt="right-arrow" />
          </button>
        </div>

        <div className="timeto-hire-card userlist ">
          <div className="tabel-application tabel-application-auto table-responsive white-space-row">
            <ToolkitProvider
              keyField="head1"
              data={data}
              columns={columns}
              search
            >
              {props => (
                <div className="table-custome-class range-custome">
                  <>
                    <div className="scroll-container">
                      <div className="table-pending-list">
                        <div className="table-wrapper" ref={tableWrapperRef}>
                          <BootstrapTable
                            {...props.baseProps}
                            pagination={paginationFactory(options)}
                            options={options}
                            rowClasses={rowClasses}
                            hover
                            responsive
                            wrapperClasses="table-wrapper"
                          />
                        </div>
                      </div>
                    </div>
                  </>
                </div>
              )}
            </ToolkitProvider>

            <div>
              {data?.filter(val => val?.checked)?.length > 0 && (
                <div className="visibledivindex  d-flex align-items-center justify-content-between">
                  <div className="visible-content">
                    <p>
                      <img src={white_cross} alt="" />
                      {data?.filter(val => val?.checked)?.length > 1
                        ? data?.filter(val => val?.checked)?.length +
                          " " +
                          t(`job-list.Applications Selected`)
                        : data?.filter(val => val?.checked)?.length +
                          " " +
                          t(`job-list.Application Selected`)}
                    </p>
                  </div>
                  <div className="visible-content delete d-flex align-items-center  justify-content-end">
                    <p
                      onClick={e => setAllArchive("draft")}
                      style={{ cursor: "pointer" }}
                    >
                      <img src={archive_ico} alt="" />
                      {t(`job-list.Draft Job`)}
                    </p>

                    <p
                      onClick={e => setAllArchive("delete")}
                      style={{ cursor: "pointer" }}
                    >
                      <img src={white_delete} alt="" />
                      {t(`job-list.Delete`)}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ArchiveJobs;
